export const callEnrolHQInit = (name) => {
  if (!window[name]) {
    return;
  }
  // There can be errors in custom js scripts.
  // They should be catched otherwise they will break `mounted` workflow.
  // Another reason is that we don't need custom js errors in sentry.
  try {
    window[name]();
  } catch (error) {
    // Make the errors visible to staff who edit custom js.
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
